// pages/NewsPage.js
import React, { useState } from "react";
import BlogSection from "../../../components/pages/overview/BlogSection";
import SEO from "../../../components/pages/SEO/SEO";
// import { useNewsPagination } from "../../hooks/news/useNewsPagination";
// import { mockBlogs, newsSeoData, backgroundImage } from "../../constants/newsData";
import { useNews } from "../../../hooks/pages/news/useNews";
import { newsSeoData, backgroundImage } from "../../../constants/pages/newsData";


export default function NewsPage() {
  const [page, setPage] = useState(1);

  const {
    news,
    loading,
    pagination,
  } = useNews(page, 6);

  return (
    <div className="bg-gray-50 min-h-screen">
      <SEO {...newsSeoData} />

      <section
        className="relative flex flex-col justify-center items-center text-center py-20 md:py-28 overflow-hidden bg-cover bg-center"
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      >
        <div className="absolute inset-0 bg-black opacity-40" />

        <div className="relative z-10 max-w-7xl px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-extrabold mb-4 font-serif">
            <span className="text-white">
              Tin tức & Blog
            </span>
          </h1>

          <p className="text-lg md:text-xl text-white max-w-2xl mx-auto">
            Cập nhật thông tin mới nhất về thị trường bất động sản.
          </p>
        </div>
      </section>

      {loading ? (
        <div className="text-center py-20">
          Loading...
        </div>
      ) : (
        <BlogSection blogs={news} />
      )}

      <div className="max-w-7xl mx-auto px-4 py-10 flex justify-center gap-3">
        {Array.from({
          length: pagination.totalPages || 0,
        }).map((_, idx) => (
          <button
            key={idx}
            onClick={() => setPage(idx + 1)}
            className={`px-4 py-2 rounded-lg border ${
              page === idx + 1
                ? "bg-[#c9a063] text-white"
                : "bg-white"
            }`}
          >
            {idx + 1}
          </button>
        ))}
      </div>
    </div>
  );
}